import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const directions = {
  right: {
    viewBox: '0 0 11 18',
    transform: 'rotate(-90) translate(-18, 0)',
  },
  left: {
    viewBox: '0 0 11 18',
    transform: 'rotate(90) translate(0, -11)',
  },
  up: {
    viewBox: '0 0 11 18',
    transform: 'rotate(180) translate(-18, -11)',
  },
  down: {
    viewBox: '0 0 11 18',
    transform: 'rotate(0) translate(0)',
  },
};

const Arrow = ({ direction = 'down', width = '25px', height = '25px' }) => (
  <svg viewBox={directions[direction].viewBox} width={width} height={height}>
    <Path transform={directions[direction].transform} d="M2.1 0L0 2.1 9 11l9-8.9L15.9 0 9 6.8 2.1 0z" />
  </svg>
);

Arrow.propTypes = {
  direction: PropTypes.string,
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

const Path = styled.path`
  fill: ${({ theme }) => `${theme.primaryColor}`};
`;

export default Arrow;
